var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconFaint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 16,
    viewBox: "0 0 6 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00335 3.99986C3.95012 3.99986 4.71763 3.23235 4.71763 2.28557C4.71763 1.3388 3.95012 0.571289 3.00335 0.571289C2.05657 0.571289 1.28906 1.3388 1.28906 2.28557C1.28906 3.23235 2.05657 3.99986 3.00335 3.99986Z",
    stroke: "#CDCED9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00335 9.71373C3.95012 9.71373 4.71763 8.94622 4.71763 7.99944C4.71763 7.05267 3.95012 6.28516 3.00335 6.28516C2.05657 6.28516 1.28906 7.05267 1.28906 7.99944C1.28906 8.94622 2.05657 9.71373 3.00335 9.71373Z",
    stroke: "#CDCED9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00335 15.4286C3.95012 15.4286 4.71763 14.6611 4.71763 13.7143C4.71763 12.7675 3.95012 12 3.00335 12C2.05657 12 1.28906 12.7675 1.28906 13.7143C1.28906 14.6611 2.05657 15.4286 3.00335 15.4286Z",
    stroke: "#CDCED9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconFaint);
export default __webpack_public_path__ + "static/media/menu-icon-faint.a3e13942.svg";
export { ForwardRef as ReactComponent };